import {
  RadarRing,
  RadarQuadrant,
  RadarEntry,
  TechRadarApi,
  TechRadarLoaderResponse,
} from '@backstage/plugin-tech-radar';

import Papa from 'papaparse';
import TurndownService from 'turndown';

export class TechRadarClient implements TechRadarApi {
  async load(id: string | undefined): Promise<TechRadarLoaderResponse> {
    // if needed id prop can be used to fetch the correct data

    const data = await fetch(
      'https://raw.githubusercontent.com/ImagineLearning/build-your-own-radar/master/radars/WNE_2020_2021.csv',
    ).then(res => res.text());

    // csv schema: name,quadrant,ring,icon,description
    const csvData = await Papa.parse(data, {
      header: true,
      skipEmptyLines: true,
    });

    const rings = new Array<RadarRing>();
    const quadrants = new Array<RadarQuadrant>();
    const entries = new Array<RadarEntry>();

    const turndownService = new TurndownService();

    csvData.data.forEach((rec: any) => {
      const entryId = rec.name.replace(/\W+/, '-');

      if (!rings.some(ring => ring.name === rec.ring)) {
        rings.push({
          id: rec.ring,
          name: rec.ring,
          color: '#93c47d',
        });
      }

      if (!quadrants.some(quadrant => quadrant.name === rec.quadrant)) {
        quadrants.push({
          id: rec.quadrant,
          name: rec.quadrant,
        });
      }

      entries.push({
        timeline: [
          {
            moved: 0,
            ringId: rec.ring,
            date: new Date('2020-08-06'),
          },
        ],
        url: '#',
        key: entryId,
        id: entryId,
        title: rec.name,
        quadrant: rec.quadrant,
        description: turndownService.turndown(rec.description),
      });
    });

    const response: TechRadarLoaderResponse = {
      entries,
      quadrants,
      rings,
    };

    return response;
  }
}
